export default __webpack_public_path__ + "static/media/golo-fireball.ccef6a48.webp";